import { render, staticRenderFns } from "./resource_list.vue?vue&type=template&id=2df9d36e&scoped=true"
import script from "./resource_list.vue?vue&type=script&lang=js"
export * from "./resource_list.vue?vue&type=script&lang=js"
import style0 from "./resource_list.vue?vue&type=style&index=0&id=2df9d36e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2df9d36e",
  null
  
)

export default component.exports